import { render, staticRenderFns } from "./StatisticsReworkAdmissionsGeneralView.vue?vue&type=template&id=708c3230"
import script from "./StatisticsReworkAdmissionsGeneralView.vue?vue&type=script&lang=js"
export * from "./StatisticsReworkAdmissionsGeneralView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports